import { render, staticRenderFns } from "./SaleManagementPlanDetail.vue?vue&type=template&id=08c848b8&scoped=true&"
import script from "./SaleManagementPlanDetail.vue?vue&type=script&lang=ts&"
export * from "./SaleManagementPlanDetail.vue?vue&type=script&lang=ts&"
import style0 from "./SaleManagementPlanDetail.vue?vue&type=style&index=0&id=08c848b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c848b8",
  null
  
)

export default component.exports